var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.2286 12.443V12.443C19.5188 12.443 18.9132 11.9585 18.6131 11.3153C18.2082 10.4473 17.6263 9.6596 16.8968 8.99974C15.8622 8.06392 14.5722 7.42273 13.1735 7.14902C11.7747 6.87532 10.3232 6.98008 8.98388 7.4514C7.64459 7.92271 6.47123 8.74169 5.59711 9.81527C4.723 10.8888 4.18318 12.174 4.03901 13.5246C3.89483 14.8753 4.15208 16.2373 4.78151 17.4559C5.41094 18.6745 6.38733 19.7009 7.59971 20.4183C8.8121 21.1358 10.2119 21.5156 11.64 21.5146H20.2286C21.494 21.5146 22.7077 21.0367 23.6025 20.1861C24.4973 19.3354 25 18.1817 25 16.9788C25 15.7758 24.4973 14.6221 23.6025 13.7715C22.7077 12.9208 21.494 12.443 20.2286 12.443Z","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Cloud.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Cloud;

Cloud.default = Cloud;
